import { RxJsonSchema } from 'rxdb';
import type { AssetsByAreaHeirachy } from './assetsByAreaHierarchy.types';

export const assetsByAreaHeirachySchema: RxJsonSchema<AssetsByAreaHeirachy> = {
  type: 'object',
  version: 0,
  description: 'describes assets BY Area Heirachy tree structure',
  primaryKey: 'type',
  properties: {
    id: { type: 'number' },
    name: { type: ['string', 'null'] },
    type: { type: 'string', maxLength: 36 },
    areaPcsId: { type: ['string', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    floorLevel: { type: ['number', 'null'] },
    siteId: { type: ['number', 'null'] },
    disciplineId: { type: ['number', 'null'] },
    trafficSafety: { type: ['number', 'null'] },
    dateModified: { type: ['string', 'null'] },
    children: {
      type: 'array',
      items: {
        type: ['object', 'null'],
        properties: {
          id: { type: 'number' },
          name: { type: ['string', 'null'] },
          type: { type: ['string', 'null'] },
          areaPcsId: { type: ['string', 'null'] },
          isActive: { type: ['boolean', 'null'] },
          floorLevel: { type: ['number', 'null'] },
          siteId: { type: ['number', 'null'] },
          disciplineId: { type: ['number', 'null'] },
          trafficSafety: { type: ['number', 'null'] },
          dateModified: { type: ['string', 'null'] },
          children: {
            type: 'array',
            items: {
              type: ['object', 'null'],
              properties: {
                id: { type: 'number' },
                name: { type: ['string', 'null'] },
                type: { type: ['string', 'null'] },
                areaPcsId: { type: ['string', 'null'] },
                isActive: { type: ['boolean', 'null'] },
                floorLevel: { type: ['number', 'null'] },
                siteId: { type: ['number', 'null'] },
                disciplineId: { type: ['number', 'null'] },
                trafficSafety: { type: ['number', 'null'] },
                dateModified: { type: ['string', 'null'] },
                children: {
                  type: 'array',
                  items: {
                    type: ['object', 'null'],
                    properties: {
                      id: { type: 'number' },
                      name: { type: ['string', 'null'] },
                      type: { type: ['string', 'null'] },
                      areaPcsId: { type: ['string', 'null'] },
                      isActive: { type: ['boolean', 'null'] },
                      floorLevel: { type: ['number', 'null'] },
                      siteId: { type: ['number', 'null'] },
                      disciplineId: { type: ['number', 'null'] },
                      trafficSafety: { type: ['number', 'null'] },
                      dateModified: { type: ['string', 'null'] },
                      lowerGridLine: { type: ['string', 'null'] },
                      upperGridLine: { type: ['string', 'null'] },
                      children: {
                        type: 'array',
                        items: {
                          type: ['object', 'null'],
                          properties: {
                            id: { type: 'number' },
                            name: { type: ['string', 'null'] },
                            type: { type: ['string', 'null'] },
                            areaPcsId: { type: ['string', 'null'] },
                            isActive: { type: ['boolean', 'null'] },
                            floorLevel: { type: ['number', 'null'] },
                            siteId: { type: ['number', 'null'] },
                            disciplineId: { type: ['number', 'null'] },
                            trafficSafety: { type: ['number', 'null'] },
                            dateModified: { type: ['string', 'null'] },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};
